import { SetDataOptions, useQueryClient } from '@tanstack/react-query';

interface Props<T> {
    queryKey: any;
    updater: (oldData: T | undefined) => T;
    options?: SetDataOptions | undefined;
}

export const useUpdateQueryData = <T>() => {
    const queryClient = useQueryClient();

    const updateQueryData = ({ queryKey, updater, options }: Props<T>) => {
        queryClient.setQueryData<T>(queryKey, updater, options);
    };

    return updateQueryData;
};
